import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from '../../../models/user.model';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html'
})
export class UserDetailComponent implements OnInit {

  userId: number;
  user: User;

  constructor(private route: ActivatedRoute) {
    this.userId = +this.route.snapshot.params.userId;
    this.route.data.subscribe(data => {
      this.user = data.userResolverResponse;
    });
  }

  ngOnInit() {}
}
